(() => {
  const root = document.documentElement;
  const key = 'purerdl_price_mode';
  const rate = Number(root.dataset.prdlVatRate || 0);
  const factor = 1 + rate / 100;
  const taxesIncluded = root.dataset.prdlTaxesIncluded === 'true';
  function createMoney(amount, taxable = true, currency = 'EUR') {
    const base = Number(amount) || 0;
    const gross = !taxesIncluded && taxable ? Math.round(base * factor) : base;
    const net = taxesIncluded && taxable ? Math.round(base / factor) : base;
    const wrapper = document.createElement('span');
    wrapper.className = 'prdl-money';
    wrapper.dataset.prdlMoney = '';
    const formatter = new Intl.NumberFormat(root.lang || 'de', {style:'currency',currency});
    for (const [mode, cents] of [['gross', gross], ['net', net]]) {
      const span = document.createElement('span');
      span.className = 'prdl-money__' + mode;
      span.textContent = formatter.format(cents / 100);
      wrapper.appendChild(span);
    }
    return wrapper;
  }
  window.PureRDLPriceDisplay = {createMoney};
  const filterFactor = () => taxesIncluded ? (root.dataset.prdlPriceMode === 'net' ? 1 / factor : 1) : (root.dataset.prdlPriceMode === 'net' ? 1 : factor);
  function parseInput(value) {
    let text = value.trim().replace(/[\s']/g, '');
    if (text.includes(',') && text.includes('.')) {
      text = text.lastIndexOf(',') > text.lastIndexOf('.') ? text.replace(/\./g, '').replace(',', '.') : text.replace(/,/g, '');
    } else text = text.replace(',', '.');
    return Number(text);
  }
  function hiddenFor(input) {
    return input.closest('price-range')?.querySelector('[data-prdl-filter-canonical="' + input.dataset.prdlFilterBound + '"]');
  }
  function syncFilter(input) {
    const hidden = hiddenFor(input);
    if (!hidden) return;
    const value = parseInput(input.value);
    hidden.value = input.value.trim() && Number.isFinite(value) ? (Math.round(value / filterFactor() * 100) / 100).toFixed(2) : '';
  }
  function refreshFilters(force = false) {
    document.querySelectorAll('price-range').forEach(range => {
      const inputs = range.querySelectorAll('[data-prdl-price-filter]');
      inputs.forEach(input => {
        if (!force && input.dataset.prdlFilterReady === 'true') return;
        const hidden = hiddenFor(input);
        if (!hidden) return;
        const f = filterFactor();
        const maximum = Number(input.dataset.prdlFilterMaximum) / 100;
        input.value = hidden.value ? (Math.round(Number(hidden.value) * f * 100) / 100).toFixed(2) : '';
        input.placeholder = input.dataset.prdlFilterBound === 'max' ? (maximum * f).toFixed(2) : '0';
        input.dataset.min = '0';
        input.dataset.max = (maximum * f).toFixed(2);
        input.dataset.prdlFilterReady = 'true';
      });
      if (inputs.length && typeof range.setMinAndMaxValues === 'function') range.setMinAndMaxValues();
    });
  }
  document.addEventListener('input', event => {
    if (event.target.matches('[data-prdl-price-filter]')) syncFilter(event.target);
  }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-prdl-price-filter]')) return;
    const value = parseInput(input.value);
    if (input.value.trim() && Number.isFinite(value)) input.value = value.toFixed(2);
    queueMicrotask(() => syncFilter(input));
  }, true);
  document.addEventListener('submit', event => {
    event.target.querySelectorAll('[data-prdl-price-filter]').forEach(syncFilter);
  }, true);
  function refreshControls(announce = false) {
    const mode = root.dataset.prdlPriceMode === 'net' ? 'net' : 'gross';
    document.querySelectorAll('[data-prdl-price-switch] button[data-prdl-price-mode]').forEach(button => {
      const pressed = button.dataset.prdlPriceMode === mode ? 'true' : 'false';
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    if (announce) {
      document.querySelectorAll('[data-prdl-price-announcement]').forEach(status => {
        status.textContent = status.dataset[mode];
      });
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-prdl-price-switch] button[data-prdl-price-mode]');
    if (!button) return;
    const mode = button.dataset.prdlPriceMode;
    if (mode !== 'gross' && mode !== 'net') return;
    root.dataset.prdlPriceMode = mode;
    try { localStorage.setItem(key, mode); } catch (error) {}
    refreshControls(true);
    refreshFilters(true);
    document.dispatchEvent(new CustomEvent('purerdl:price-mode-change', {detail:{mode}}));
  });
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    root.dataset.prdlPriceMode = event.newValue === 'net' ? 'net' : 'gross';
    refreshControls();
    refreshFilters(true);
  });
  document.addEventListener('shopify:section:load', () => {refreshControls();refreshFilters();});
  const observedSelector = '[data-prdl-price-switch],[data-prdl-price-filter]';
  let refreshQueued = false;
  new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(observedSelector) || node.querySelector(observedSelector))));
    if (!relevant || refreshQueued) return;
    refreshQueued = true;
    queueMicrotask(() => {refreshQueued=false;refreshControls();refreshFilters();});
  }).observe(document.body, {childList:true,subtree:true});
  refreshControls();
  refreshFilters();
})();
